// extracted by mini-css-extract-plugin
export var blue = "_4f-h";
export var brand = "_4f-d";
export var darkGrey = "_4f-g";
export var disabled = "_4f-6";
export var disabledSubtle = "_4f-7";
export var error = "_4f-8";
export var green = "_4f-i";
export var grey = "_4f-f";
export var icon = "_4f-0";
export var inherit = "_4f-c";
export var lightGrey = "_4f-e";
export var orange = "_4f-k";
export var pink = "_4f-m";
export var primary = "_4f-1";
export var purple = "_4f-n";
export var quaternary = "_4f-4";
export var quinary = "_4f-5";
export var red = "_4f-l";
export var secondary = "_4f-2";
export var success = "_4f-b";
export var tertiary = "_4f-3";
export var warning = "_4f-9";
export var warningSecondary = "_4f-a";
export var white = "_4f-o";
export var yellow = "_4f-j";